import { memo } from 'react'
import './Loading.css'

const Loading = memo(({
  size = 'medium',
  text = '',
  variant = 'circle',
  inline = false,
  fill = false,
  className = '',
}) => {
  const label = text || 'Henter'

  return (
    <div
      className={[
        'loading',
        `loading--${size}`,
        `loading--${variant}`,
        inline ? 'loading--inline' : '',
        fill ? 'loading--fill' : '',
        className,
      ].filter(Boolean).join(' ')}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <svg className="loading__mark" viewBox="0 0 40 40" aria-hidden="true" focusable="false">
        <circle className="loading__track" cx="20" cy="20" r="16" />
        <circle className="loading__arc" cx="20" cy="20" r="16" />
      </svg>
      {text ? <span className="loading__text">{text}</span> : null}
    </div>
  )
})

Loading.displayName = 'Loading'

export default Loading
